<template lang="pug">
  .owner-relatives(v-if="relatives.length" )
    .owner-relatives__title.semibold В собственности
    .table
      .table__row
        .table__col.table__head.table__col_third Наименование
        .table__col.table__head.table__col_third Тип объекта
        .table__col.table__head.table__col_third Место нахождения
      .table__body
        .table__row(v-for="item in relatives" :key="item.id" )
          .table__col.table__col_third
            router-link(
              :to="setRoute(item)"
            ) {{item.name}}
          .table__col.table__col_third {{ item.type}}
          .table__col.table__col_third {{item.address}}
</template>
<script>
import { owner } from '@/api/api-endpoints'
import url from '@/utils/url'

const NAMES = {
  'Контейнерная площадка': 'withContainers',
  'Бесконтейнерный сбор': 'withoutContainers',
  'Раздельный сбор': 'separateCollections',
  'Пункты сбора вторсырья': 'recyclablesCollections',
  'Мусороприемная камера': 'wasteCollections',
  'Специальная площадка для КГО': 'specialKgoCollections',
  'Индивидуальные домовладения': 'individual_area',
  'Несанкционированная свалка': 'heaps',
  'Управляющие организации': 'uk',
  'Садовые, дачные товарищества': 'country_community',
  МКД: 'mkd',
  'Объекты животноводства': 'animal_husbandry',
  'Объекты рекреационного назначения': 'recreatio_purpose',
  'Объекты сельскохозяйственнного назначения': 'agricultural_purpose',
}
const TYPES = {
  msn: 'msn',
  garbage_source: 'garbage',
  unauthorized_heap: 'unauthorized',
  repty: 'msn',
}
export default {
  name: 'owner-relatives',
  data: () => ({
    relatives: [],
  }),
  methods: {
    async getRelatives(id) {
      this.relatives = (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: owner.relations(id),
        })
      ).data.data
    },
    setRoute(item) {
      let prevRoute = url.getRoute(this.$route, true)
      return {
        name: `${TYPES[item.entity]}.${NAMES[item.type]}.update`,
        params: {
          id: item.id,
        },
        query: { prevRoute },
      }
    },
  },
  created() {
    this.getRelatives(this.$route.params.id)
  },
}
</script>
